import React from "react";

import { Task } from "api/types/users";
import { UserTaskType } from "../Interfaces";
import InsuranceCardUpload from "./InsuranceCardUpload";
import DiagnosisFormUpload from "./DiagnosisFormUpload";

interface ImageUploadTaskProps {
  data: Task;
  setCurrentTask: (task: Task | null) => void;
  onUploadSuccess: () => void;
}

const ImageUploadTask = ({ data, setCurrentTask, onUploadSuccess }: ImageUploadTaskProps) => {
  const { type: taskType, metadata } = data;

  if (taskType !== UserTaskType.IMAGE_UPLOAD) {
    console.warn(`ImageUploadTask: Task type ${taskType} is not supported`);
    return null;
  }
  const handleOnExited = () => {
    setCurrentTask(null);
  };

  if (
    metadata?.documentType === "INSURANCE_CARD_FRONT" ||
    metadata?.documentType === "INSURANCE_CARD_BACK"
  ) {
    return (
      <InsuranceCardUpload
        data={data}
        onExited={handleOnExited}
        onUploadSuccess={onUploadSuccess}
      />
    );
  }

  if (metadata?.documentType === "DIAGNOSIS_FORM") {
    return (
      <DiagnosisFormUpload
        task={data}
        onExited={handleOnExited}
        onUploadSuccess={onUploadSuccess}
      />
    );
  }

  return null;
};

export default ImageUploadTask;
